import React from 'react';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import bannerStyles from '../../../components/subscription/FeatureLockBanner.module.css';
import { seatLimitMessage } from './seatUsage';
import useCurrentPlanLabel from '../../../components/subscription/useCurrentPlanLabel';
import { LIMIT_UPGRADE_BUTTON } from '../../../components/subscription/planLockTexts';

/**
 * Aviso de vagas cheias na tela de usuários, com o visual do FeatureLockBanner:
 * diz quantas vagas o plano tem, quantas estão em convite, e leva para a troca de plano.
 */
function SeatLimitNotice({ usage, limit, onUpgradeClick }) {
  const planLabel = useCurrentPlanLabel();
  return (
    <div className={bannerStyles.banner} role="alert">
      <div className={bannerStyles.content}>
        <WarningAmberIcon className={bannerStyles.icon} fontSize="small" />
        <span className={bannerStyles.message}>{seatLimitMessage(usage, limit, planLabel)}</span>
      </div>
      <button className={bannerStyles.upgradeButton} onClick={onUpgradeClick} type="button">
        {LIMIT_UPGRADE_BUTTON}
      </button>
    </div>
  );
}

export default SeatLimitNotice;
